import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'ai-tool', {
    toolSearch: 'Search tools',
    toolSearchReasoning:
      'Searching deferred tools: {{toolCall.input.query}} (max {{toolCall.input.maxResults}})',
    toolSearchOutput: 'Found {{count}} matching tools for {{toolCall.input.query}}: {{toolsFound}}',
    toolSearchNoop: 'No matching tools for {{toolCall.input.query}}',
    toolSearchError: 'Error searching tools for {{toolCall.input.query}}: {{errorMessage}}',
    loadTool: 'Load tool',
    loadToolReasoning: 'Loading tool: {{toolCall.input.toolKey}}',
    loadToolOutput: 'Loaded {{toolCall.input.toolKey}} for direct use',
    loadToolNoop: '{{toolCall.input.toolKey}} is already active',
    loadToolError: 'Error loading {{toolCall.input.toolKey}}: {{errorMessage}}',
    unloadTool: 'Unload tool',
    unloadToolReasoning: 'Unloading tool: {{toolCall.input.toolKey}}',
    unloadToolOutput: 'Unloaded {{toolCall.input.toolKey}} from active set',
    unloadToolNoop: '{{toolCall.input.toolKey}} was not in the active set',
    unloadToolError: 'Error unloading {{toolCall.input.toolKey}}: {{errorMessage}}',
    compact: 'Compact context',
    compactReasoning: 'Scheduling context compaction before the next step',
    compactOutput: 'Compaction scheduled for the next step',
    compactError: 'Error scheduling compaction: {{errorMessage}}',
  });
}
